import { FiEdit } from "react-icons/fi";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { Button } from "flowbite-react";

const ButtonTableEdit = (props) => {
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "yellow",
    className: `lg:w-8 lg:h-8 w-7 h-7 flex justify-center items-center rounded-[4px] ${props.className}`,
  };
  return (
    <Button {...tmpProps}>
      <FiEdit className="text-gray-600 font-medium" size={20} />
    </Button>
  );
};

export default ButtonTableEdit;
